<div mat-dialog-title style="color:#b71c1c;">No Student Selected</div>

<mat-dialog-content>
  <div>No information can be displayed because a student has not been selected.</div>
  <div style="padding-top:20px;">Select OK to log out.</div>
  <div style="padding-top:20px;">Select Cancel to return to the Student Search.</div>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="flex-footer-right">
    <tyl-button id="studentSearchWarningOKButton" image="save.png" label="OK" (clickEvent)="okClick()">
    </tyl-button>
    <tyl-button id="studentSearchWarningCancelButton" image="cancel.png" label="Cancel" (clickEvent)="cancelClick()">
    </tyl-button>
  </div>
</mat-dialog-actions>